import TabPanelReview from './TabPanelReview';

export default TabPanelReview;
